// extracted by mini-css-extract-plugin
export default {"root":"hUK4o","starsLeft":"smvyh","starsRight":"hGgZH","xs":"Eba12","small":"kV9oi","medium":"KmzSo","large":"vpRYz"};